'use client';

import { useEffect } from 'react';
import { pageTrackingObjectUpdate } from 'utils/tagular';

export const useCohesionConfig = (pageType: string) => {
  useEffect(() => {
    pageTrackingObjectUpdate(pageType, true);
  }, [pageType]);
};
